const ViewDisputeApply = () => import('../modules/xmsb/energy/operators/ViewDisputeApplyGzl')

export default [
  {

    path: '/disputeapplyview',
    name: 'disputeapplyview',
    component: ViewDisputeApply,
    meta: {
      title: '申请处理境外劳务纠纷和突发事件费用补助',
      fullscreen: true,
    },
  },
]
